import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { MlflowModelSummary } from '@internal/plugin-mlflow-common';
import { MlflowApi } from './MlflowApi';

// MLflow кластера модели (аннотация viva.company.com/cluster): бэкенд сам находит адрес по каталогу
const clusterQuery = (cluster?: string) => (cluster ? `?cluster=${encodeURIComponent(cluster)}` : '');

export class MlflowApiClient implements MlflowApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getModelSummary(modelName: string, cluster?: string): Promise<MlflowModelSummary> {
    return this.request(`/models/${encodeURIComponent(modelName)}${clusterQuery(cluster)}`);
  }

  async promote(
    modelName: string,
    alias: string,
    version: string,
    cluster?: string,
  ): Promise<MlflowModelSummary> {
    return this.request(`/models/${encodeURIComponent(modelName)}/promote${clusterQuery(cluster)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ alias, version }),
    });
  }

  private async request<T>(path: string, init?: RequestInit): Promise<T> {
    const baseUrl = await this.discoveryApi.getBaseUrl('mlflow');
    const response = await this.fetchApi.fetch(`${baseUrl}${path}`, init);

    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(
        payload?.error?.message ??
          payload?.error ??
          `MLflow request failed with status ${response.status}`,
      );
    }

    return (await response.json()) as T;
  }
}
